// socket.js
import { io } from "socket.io-client";

let socket = null;
let currentLocationId = null;

let listeners = {
  InitialB2BLiveLocationFeed: [],
  sendB2BDriverLocationUpdate: [],
  sosB2BAlert: [] // Add sosAlerts to listeners
};

export function initSocketConnection(url, options = {}) {

  const { 
    locationId = null, 
    socketPath = '', 
    authToken = localStorage.getItem('token')
  } = options;
  // Disconnect previous socket if locationId changed

  if (socket && locationId !== currentLocationId) {
    socket.disconnect();
    socket = null;
    currentLocationId = null;
  }

  // If socket already exists for current locationId, return it
  if (socket) return socket;

  // Prepare socket configuration
  const socketConfig = {
    reconnectionDelay: 10000,
    transports: ['websocket'],
    path: socketPath,
    auth: {
      token: authToken
    }
  };

  // Add filters only if locationId is provided
  if (locationId) {
    socketConfig.auth.filters = {
      city: locationId
    };
  }

  // Create new socket
  socket = io(url, socketConfig);

  currentLocationId = locationId;

  socket.on("connect", () => {
    socket.emit("INIT", {
      client: "frontend",
      timestamp: Date.now(),
    });
  });

  socket.on("InitialB2BLiveLocationFeed", (data) => {
    listeners.InitialB2BLiveLocationFeed.forEach((cb) => cb(data));
  });

  socket.on("sendB2BDriverLocationUpdate", (data) => {
    listeners.sendB2BDriverLocationUpdate.forEach((cb) => cb(data));
  });

  // Listen for sosAlerts event
  socket.on("sosB2BAlert", (data) => {
    listeners.sosB2BAlert.forEach((cb) => cb(data));
  });

  socket.on("disconnect", () => {
    console.warn("Socket.io disconnected");
  });

  socket.on("connect_error", (error) => {
    console.error("Socket.io connection error:", error);
  });

  return socket;
}

export function subscribeToSocket(event, callback) {
  if (!listeners[event]) listeners[event] = [];
  listeners[event].push(callback);
  return () => {
    listeners[event] = listeners[event].filter((cb) => cb !== callback);
  };
}

